import { render, staticRenderFns } from "./ActionsMenu.vue?vue&type=template&id=4267004e"
import script from "./ActionsMenu.ts?vue&type=script&lang=ts&external"
export * from "./ActionsMenu.ts?vue&type=script&lang=ts&external"
import style0 from "./ActionsMenu.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports